import React from 'react';
import './VendorForm.css';

// Vendor Details page: the vendor's saved prices (vendor_payout_price), grouped by service, then service type,
// with the offerings as rows and the service locations as columns.
const VendorPricing = ({ vendorData }) => {
  const currency = String(vendorData?.phone_number || '').startsWith('91') ? '\u20B9' : 'AED ';
  const rows = vendorData?.payout_prices || [];

  // service -> type -> offering -> location -> amount. Grouped by id, so two things with the same name stay apart.
  const services = [];
  for (const r of rows) {
    let service = services.find((s) => s.id === r.service_id);
    if (!service) services.push((service = { id: r.service_id, name: r.service_name, types: [] }));
    let type = service.types.find((t) => t.id === r.service_type_id);
    if (!type) service.types.push((type = { id: r.service_type_id, name: r.type_name, locations: [], offerings: [] }));
    if (!type.locations.some((l) => l.id === r.service_location_id)) type.locations.push({ id: r.service_location_id, name: r.location_name });
    let offering = type.offerings.find((o) => o.id === r.offering_id);
    if (!offering) type.offerings.push((offering = { id: r.offering_id, name: r.offering_name, prices: {} }));
    offering.prices[r.service_location_id] = r.payout_amount;
  }

  return (
    <div className="vp-view">
      <div className="row secondary">
        <h1 className="sub-heading mt-3">Price Offering</h1>
        {services.length === 0 && <p className="label">No prices have been added for this vendor yet.</p>}
        {services.map((service) => (
          <div key={service.id} className="vp-service">
            <div className="vp-service-title">{service.name}</div>
            {service.types.map((type) => (
              <div key={type.id || type.name} className="vp-offering">
                {type.name && <div className="vp-offering-head">{type.name}</div>}
                <div className="vp-scroll">
                  <table className="vp-table">
                    <thead>
                      <tr>
                        <th>Offering</th>
                        {type.locations.map((l) => <th key={l.id}>{l.name}</th>)}
                      </tr>
                    </thead>
                    <tbody>
                      {type.offerings.map((o) => (
                        <tr key={o.id}>
                          <td className="vp-loc">{o.name}</td>
                          {type.locations.map((l) => (
                            <td key={l.id}>{o.prices[l.id] === undefined ? '—' : `${currency}${o.prices[l.id]}`}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default VendorPricing;
